import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { InvoiceLineModel } from './invoiceline.model';
import { ConceptModel } from '../../concept/concept/concept.model';
import { InvoiceTaxModel } from './invoicetax.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { map, Observable, startWith } from 'rxjs';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PreinvoiceFormComponent } from './preinvoice-form.component';
import { BarcodeDialogComponent } from './barcode-dialog.component';
import { ConceptSerialNumberComponent } from '../../concept/concept/serialNumber/concept-serialNumber.component';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';

@Component({
    selector: 'convfact-preinvoice-form-item',
    templateUrl: './preinvoice-form-item.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})
export class PreinvoiceFormItemComponent implements OnInit {

  @Input() item = new InvoiceLineModel();
  @Input() taxes = Array<InvoiceTaxModel>();
  @Input() concepts = Array<ConceptModel>();

  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<ConceptModel[]>;


  unitMeasurable: MasterModel[] = [];
  filteredUnitMeasurable: MasterModel[] = [];

  constructor(
    private conceptService: ConceptService,
    public dialogRef: MatDialogRef<PreinvoiceFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taxCalculator: TaxCalculator,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private masterService: MasterService,) { }

  toZero() {
    this.item.unityAmount = 0;
  }

  //Detectar código de barras en campo Concepto
  onConceptEnter(code: string) {
    this.conceptService.barcode(code).then(result => {
      if (result) {
        this.item.product = result.name;
        this.item.conceptUid = result.uid;
        this.item.quantity = 1;
        this.item.unityAmount = result.netPrice;
        this.item.netPrice = result.netPrice;
        this.item.taxes = result.taxes;
        this.item.discount = 0;
      } else {
        alert('No se encontró concepto para el código: ' + code);
      }
    });
  }
  //------------------------------------------


  filterConcepts(val) {
    const self = this;
    for (const concept of this.concepts) {
      if (concept.name == val) {
        self.item.conceptUid = concept.uid;
        self.item.quantity = 1;
        self.item.unityAmount = concept.netPrice;
        self.item.netPrice = concept.netPrice;
        self.item.taxes = concept.taxes;
        self.item.discount = 0;
      }
    }

    const normalizedValue = this.normalize(val);
    return val
      ? this.concepts.filter(concept =>
        this.normalize(concept.shortcut).startsWith(normalizedValue) ||
        this.normalize(concept.name).startsWith(normalizedValue)
      )
      : this.concepts;
  }

  // // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  // private normalize(str: string): string {
  //   return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  // }

  ngOnInit() {

    this.conceptService.getList().then(concepts => {
      this.concepts = concepts;
    });


    this.conceptCtrl = new UntypedFormControl();
    this.filteredConcepts = this.conceptCtrl.valueChanges.pipe(
      startWith(''),
      map(concept => concept && typeof concept === 'object' ? concept.shortcut : concept),
      map(name => this.filterConcepts(name))
    );

    this.taxes = this.data.taxes || [];

    this.masterService.getUnitMeasurables().subscribe(result => {
      this.unitMeasurable = result;
      this.filteredUnitMeasurable = result;

      // if (this.item.masterMeasurableUid) {
      //   const selectedMeasurable = this.measurable.find(m => m.id === this.item.masterMeasurableUid);
      //   if (selectedMeasurable) {
      //     const meta = Number(selectedMeasurable.metadata);
      //     this.filteredUnitMeasurable = this.unitMeasurable.filter(
      //       (u: any) => Number(u.metadata) === meta
      //     );

      //     if (
      //       this.item.masterUnitMeasurableUid &&
      //       !this.filteredUnitMeasurable.some(u => u.id === this.item.masterUnitMeasurableUid)
      //     ) {
      //       this.item.masterUnitMeasurableUid = '';
      //     }
      //   }
      // }

      // else 
      if (this.data.item.masterUnitMeasurableUid) {
        const selectedUnit = this.unitMeasurable.find(
          (u: any) => u.id === this.data.item.masterUnitMeasurableUid
        );
        this.filteredUnitMeasurable = selectedUnit ? [selectedUnit] : this.unitMeasurable;
      }
    });


    const indexes = [];
    for (let i = 0; i < this.data.item.taxes.length; i++) {
      if (this.data.item.taxes[i] == null) {
        indexes.push(i);
      }
    }
    for (let j = 0; j < indexes.length; j++) {
      this.data.item.taxes.splice(j, 1);
    }


    this.item = {
      product: this.data.item.product,
      conceptUid: this.data.item.conceptUid,
      conceptCode: this.data.item.conceptCode,
      quantity: this.data.item.quantity,
      discount: this.data.item.discount,
      unityAmount: this.data.item.unityAmount,
      netPrice: this.data.item.netPrice,
      position: this.data.item.position,
      totalLine: this.data.item.totalLine,
      taxes: new Array<InvoiceTaxModel>(),


      // masterMeasurableUid: this.data.item.masterMeasurableUid || this.data.item.masterMeasurableId || '',
      masterUnitMeasurableUid: this.data.item.masterUnitMeasurableUid || this.data.item.masterUnitMeasurableId || '',
      quantityMeasurable: this.data.item.quantityMeasurable,

      isMeasurable: (this.data.item.isMeasurable ||
        this.data.item.masterMeasurableId != null ||
        this.data.item.masterUnitMeasurableId != null) ? true : false
    };


    for (let i = 0; i < this.data.item.taxes.length; i++) {
      this.setTax(this.data.item.taxes[i], this.item);
    }
  }


  onToggleIsMeasurable(): void {
    if (!this.item.isMeasurable) {

      this.item.masterMeasurableUid = '';
      this.item.masterUnitMeasurableUid = '';
      this.filteredUnitMeasurable = [];
    } else {

      this.filteredUnitMeasurable = this.unitMeasurable;
    }
  }


  displayFn(concept: ConceptModel) {
    if (concept != null) {
      this.item.conceptUid = concept.uid;
      this.item.quantity = 1;
      this.item.unityAmount = concept.netPrice - (concept.netPrice * (concept.discount / 100));
      this.item.netPrice = concept.netPrice;

      if (concept.discount != null && concept.discount > 0) {
        this.item.product = concept.name + " - " + concept.discount + "% descuento (aplicado a " + concept.netPrice + ")";
      }

      if (concept.barcode || concept.model || concept.size) {
        const extras: string[] = [];

        if (concept.barcode) {
          extras.push(`Código: ${concept.barcode}`);
        }
        if (concept.model) {
          extras.push(`Modelo: ${concept.model}`);
        }
        if (concept.size) {
          extras.push(`Talla: ${concept.size}`);
        }

        this.item.product += " - " + extras.join(" - ");
      }

      if (concept.serialNumber) {
        const dialogRef = this.dialog.open(ConceptSerialNumberComponent, {
          width: '640px',
          maxWidth: '96vw',
          height: '70%',
          data: {
            concept: concept,
            live: true
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.item.product = this.item.product + " - S/N: " + result;
          }
        });
      }
    }
  }


  // filterConcepts(val) {
  //   const normalizedValue = this.normalize(val);
  //   return val
  //     ? this.concepts.filter(c => this.normalize(c.shortcut).includes(normalizedValue))
  //     : this.concepts;
  // }

  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }


  onSelectTax(taxId: number): void {
    const taxFinded = this.taxes.find(c => c.id == taxId);
    if (taxFinded) this.setTax(taxFinded, this.item);
  }

  // onSelectMeasurable(measurableId: string): void {
  //   if (!measurableId) return;

  //   // 🔹 Buscamos el tipo seleccionado en la lista
  //   const measurableFound = this.measurable.find(m => m.id === measurableId);

  //   if (!measurableFound) {
  //     console.warn('No se encontró el tipo medible con id:', measurableId);
  //     this.filteredUnitMeasurable = this.unitMeasurable;
  //     return;
  //   }

  //   const measurableNumericId = Number(measurableFound.metadata);

  //   this.filteredUnitMeasurable = this.unitMeasurable.filter(
  //     (unit: any) => Number(unit.metadata) === measurableNumericId
  //   );

  //   if (
  //     this.item.masterUnitMeasurableUid &&
  //     !this.filteredUnitMeasurable.some(u => u.id === this.item.masterUnitMeasurableUid)
  //   ) {
  //     this.item.masterUnitMeasurableUid = '';
  //   }
  // }

  setTax(tax: InvoiceTaxModel, item: InvoiceLineModel): void {

    if (item.taxes.some(t => t.id === tax.id)) {
      this.displayInfo('Este impuesto ya ha sido aplicado.');
      return;
    }

    const isRecargoEquiv = tax.name.toLowerCase().includes('recargo equiv');
    const mismoTipo = item.taxes.filter(t =>
      t.type === tax.type && !t.name.toLowerCase().includes('recargo equiv')
    );

    if (!isRecargoEquiv && mismoTipo.length > 0) {
      this.displayInfo(`Ya se ha aplicado un impuesto del tipo ${tax.type}.`);
      return;
    }

    item.taxes.push(tax);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 3000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  changeChips = function (element: PreinvoiceFormItemComponent) {
    element.item.taxes.forEach(tax => {
      element.setTax(tax, element.item);
    });
  }


  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onSave(): void {
    this.dialogRef.close({
      action: 'save',
      item: this.item
    });
  }

  barcode() {
    this.dialog.open(BarcodeDialogComponent, {
    })
      .afterClosed().subscribe(result => {
        const data = result['concept'];
        if (data.uid !== "00000000-0000-0000-0000-000000000000") {
          this.item.conceptCode = data.conceptCode;
          this.item.conceptUid = data.uid;
          this.item.netPrice = data.netPrice;
          this.item.product = data.name;
          this.item.taxes = data.taxes;
          this.item.unityAmount = data.netPrice;
          if (data['serialNumber']) {
            const dialogRef = this.dialog.open(ConceptSerialNumberComponent, {
              width: '640px',
              maxWidth: '96vw',
              height: '70%',
              data: {
                concept: data,
                live: true
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.item.product = this.item.product + " - S/N: " + result;
              }
            });
          }
        }

      });
  }
  public trackByIndex(i: number) { return i; }

}
